import React from 'react';
import PropTypes from 'prop-types';
import {
    GameContextWrapper,
    MatchupLayout,
    GameDetailsLayout,
    GameActionsLayout,
    DetailsLayoutContainer
} from './GameContext.style';
import { TeamMatchupLayer } from './components/TeamMatchupLayer';
import { GameDetailsLayer } from './components/GameDetailsLayer';
import { GameActionsLayer } from './components/GameActionsLayer';

const GameContext = ({
    gameState,
    gameDetailInfo,
    broadcastInfo,
    language,
    useFullViewport,
    timezone
}) => {
    return (
        <GameContextWrapper $useFullViewport={useFullViewport}>
            <DetailsLayoutContainer>
                <MatchupLayout>
                    <TeamMatchupLayer
                        gameState={gameState}
                        language={language}
                        timezone={timezone}
                        {...gameDetailInfo}
                    />
                </MatchupLayout>
                <GameDetailsLayout>
                    <GameDetailsLayer gameState={gameState}/>
                </GameDetailsLayout>
            </DetailsLayoutContainer>
            <GameActionsLayout>
                <GameActionsLayer
                    gameState={gameState}
                    {...broadcastInfo}/>
            </GameActionsLayout>
        </GameContextWrapper>
    );
};

GameContext.propTypes = {
    gameState: PropTypes.string,
    gameDetailInfo: PropTypes.object,
    broadcastInfo: PropTypes.object,
    language: PropTypes.string,
    useFullViewport: PropTypes.bool,
    timezone: PropTypes.string
};

export default GameContext;
